import { GetJSONRouteAsync } from "../../FileAccess";


export type AvatarNationality = {
    name: string;
    symbol: string
}

export type AvatarVerification = {
    name: string;
    symbol: string
}

export type AvatarFanStatus = {
    combinedStatus: string,
    recognition: string,
    contentType: string,
    fanType: string,
    verificationTick: AvatarVerification
}

export type AvatarPoints = {
    fanPoints: number,
    researchPoints: number
}

export type AvatarInterests = {
    [key: string]: []
}

export type AvatarRecentActivity = {
    action: string,
    event: string,
    time: string,
    category: string
}

export type AvatarAchievment = {
    name: string,
    description: string,
    rarity: string,
    symbol: string,
    color: string
}

export type AvatarProfile = {
    username: string,
    name: string,
    gender: string,
    nationality: AvatarNationality,
    fanStatus: AvatarFanStatus,
    points: AvatarPoints,
    interests: AvatarInterests,
    recentActivities: AvatarRecentActivity[],
    achievements: AvatarAchievment[],
    profilePicture: string
}

export const GetAvatarProfile = async (nickname: string): Promise<AvatarProfile> => {
    const ret: AvatarProfile = (await GetJSONRouteAsync(nickname, 'profiles.users')) as AvatarProfile;
    return ret;
}

export const GetAvatarService = async (nickname: string): Promise<AvatarProfile> => {
    const uri = '/api/avatar/' + nickname;
    const response = await fetch(uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
    });
    const json = await response.json();
    const payload = json as AvatarProfile;
    return payload;
}